import { exportExcel } from "@api/stores/warehouseCirculation/exportExcel/path";
import { exportPDF } from "@api/stores/warehouseCirculation/exportPDF/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/warehouse-circulations/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const warehouseCirculations = {
  getAll: apiPathFunc(pathBase),
  exportPDF,
  exportExcel,
};
